import React from "react";
import classNames from "classnames";
import { routesMap } from "@/components/routes/routes";
import OpticksIcon from "../ui/OpticksIcons/OpticksIcon";
import SelfservicePlanSelector from "./SelfservicePlanSelector/SelfservicePlanSelector";
import "./AuthRoute.css";

interface Props {
  children?: React.ReactNode;
}

const SelfserviceContent = () => (
  <div className="marketing-message">
    <SelfservicePlanSelector />
  </div>
);

const GenericContent = () => (
  <div className="marketing-message">
    <h1>
      While you were away
      <br />
      <span className="highlight">Opticks has been auditing your traffic</span>
      <br />
      and preventing ad fraud for you.
    </h1>
  </div>
);

const GenericContentWithTitle = () => (
  <div className="marketing-message">
    <h1>
      Welcome to Opticks!
      <br />
      <span className="highlight">Let us do the hard work for you.</span>
      <br />
      Opticks has been auditing your traffic
      <br />
      and preventing ad fraud for you.
    </h1>
  </div>
);

/**
 *
 * @param Component
 * @param auth
 * @returns {*}
 * @constructor
 */

const AuthRoute = ({ children }: Props) => {
  let Content = null;

  switch (window.location.pathname) {
    case routesMap.auth.login.path:
    case routesMap.emailVerification.path:
      Content = <GenericContent />;
      break;
    case routesMap.auth.signup.path:
    case routesMap.auth.googleSignup.path:
      Content = <GenericContentWithTitle />;
      break;
    case routesMap.auth.signupPlan.path:
      Content = <SelfserviceContent />;
      break;
    default:
      Content = <OpticksIcon size={100} />;
      break;
  }

  const isSignupPlan =
    window.location.pathname === routesMap.auth.signupPlan.path;

  return (
    <div
      className={classNames("auth-view", {
        "auth-view--signup-plan": isSignupPlan,
      })}
    >
      <div id="plan-selector-anchor" className="auth-view-marketing">
        {Content}
      </div>
      <div className="auth-view-form">{children}</div>
    </div>
  );
};

export default AuthRoute;
